import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "✔", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "ml10",
  style: {"margin-top":"-3px"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "fl pad5",
  style: { width: `168px` }
}
const _hoisted_11 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`fl fw600 mr5 pointer selected circleBlueButton small`)
}
const _hoisted_12 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`fl fw600 mr5 greenBg padw3 rad10 fs11`)
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(`OnePossibleDate ${_ctx.listStyle == `flat` ? `fl mr5 mb3` : `w100`} hoverLightGrey pointer ${
            _ctx.useSelectbox && _ctx.pd.selected ? `selected` : ``
        } wday${_ctx.pd.wday} date${_ctx.pd.date_format}`),
    id: `${_ctx.idprefix}date${_ctx.pd.short_format.slice(0, 4)}`,
    onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseoverLi && _ctx.mouseoverLi(...args))),
    onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseleaveLi && _ctx.mouseleaveLi(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`${_ctx.isSP ? `w100` : `fl`} ${_ctx.listStyle == `flat` ? `fl` : `w100`} arial dateFormatContent `),
      style: _normalizeStyle({
                marginTop: _ctx.showGroups ? `3px` : ``,
            })
    }, [
      (_ctx.canDelete)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "fr mt12",
            style: { width: `16px` },
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeDate && _ctx.removeDate(...args)))
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
              width: "16",
              height: "19"
            }, null, 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      ([`top`, `asview`, `sel`].includes(_ctx.idprefix))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(`posRe fs20 fw600 pointer centered circle_button blueAround rad8 ${
                    _ctx.idprefix == `sel` ? `w100` : `w100`
                } fl`),
            style: _normalizeStyle(_ctx.isSP && !_ctx.showGroups ? {} : { width: `265px`, display: `flex`, justifyContent: `center` }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmFixSchedule(_ctx.pd)))
          }, [
            (_ctx.useSelectbox && _ctx.pd.selected)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "posAb skyblue fs20",
                  style: _normalizeStyle({ width: `30px`, top: `10px`, left: `${_ctx.isSP ? `2px` : `20px`}` })
                }, _hoisted_4, 4))
              : _createCommentVNode("", true),
            (_ctx.pd.tz_format)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.pd.tz_format.split(`, `)[1]), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.pd.jp_format.split(`）`)[1]), 1)),
            (_ctx.pdm.checkConflicts)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.pd.is_conflict)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.$getAssetImageUrl(`/assets/icons/attendee_ng.png`),
                        width: "16",
                        height: "16"
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.$getAssetImageUrl(`/assets/icons/attendee_ok.png`),
                        width: "16",
                        height: "16"
                      }, null, 8, _hoisted_9))
                ]))
              : _createCommentVNode("", true),
            (_ctx.pd.is_group_event && _ctx.showMaxBookings())
              ? (_openBlock(), _createElementBlock("p", {
                  key: 4,
                  class: "posAb lgreyBg dgrey fs14 padw2 arial rad4",
                  style: _normalizeStyle({ bottom: `2px`, right: `${_ctx.isSP ? `2px` : `6px`}` })
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.maxBookingsText), 1)
                ], 4))
              : _createCommentVNode("", true)
          ], 6))
        : _createCommentVNode("", true),
      (_ctx.showGroups)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pdGroups, (mag, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: `${mag.id}${index}`
              }, [
                (mag && mag.name && !mag.is_sub_astag)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(mag.name), 1))
                  : (mag && mag.name && mag.is_sub_astag)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(mag.name), 1))
                    : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_13
    ], 6),
    _hoisted_14
  ], 42, _hoisted_1))
}